<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/* NUCLEAR FIX: Size Chart Override */
(function() {
    // 1. Define the logic that we KNOW works (from your console test)
    function forceOpenSizeChart(e) {
        if(e) {
            e.preventDefault();
            e.stopImmediatePropagation(); // STOP theme from interfering
        }
        
        console.log("Size Chart Override: Triggered");

        // Force body class
        document.body.classList.add('size-chart-show');

        // Find popup
        var popup = document.getElementById('halo-size-chart-popup');
        
        if(popup) {
            // Move to body if not already there (fixes Z-Index/Overlay issues)
            if (popup.parentNode !== document.body) {
                document.body.appendChild(popup);
            }

            // Apply the styles that you confirmed work
            popup.classList.add('is-show');
            popup.style.cssText = 'display: block !important; z-index: 2147483647 !important; background-color: white !important; position: fixed !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; width: 90%; max-width: 800px; max-height: 90vh; overflow-y: auto; opacity: 1 !important; visibility: visible !important;';
            
            // Force image visibility
            var images = popup.getElementsByTagName('img');
            for (var i = 0; i < images.length; i++) {
                images[i].style.cssText = 'display: block !important; opacity: 1 !important; visibility: visible !important; margin: 0 auto; max-width: 100%;';
            }
        } else {
            console.error("Size Chart Override: Popup not found");
        }
    }

    // 2. Attach to button using "Capture" phase to run BEFORE theme JS
    document.addEventListener('click', function(e) {
        var target = e.target;
        // Check if user clicked the size chart link or icon inside it
        if (target.matches('[data-open-size-chart-popup]') || target.closest('[data-open-size-chart-popup]')) {
            forceOpenSizeChart(e);
        }
        
        // Close logic
        if (target.matches('[data-close-size-chart-popup]') || target.closest('[data-close-size-chart-popup]') || target.classList.contains('background-overlay')) {
            if (document.body.classList.contains('size-chart-show')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                document.body.classList.remove('size-chart-show');
                var popup = document.getElementById('halo-size-chart-popup');
                if(popup) popup.style.display = 'none';
            }
        }
    }, true); // "true" here enables Capture Phase (High Priority)
})();


